export type PurchaseIntent = {
  source?: 'trial';
  planId: 'pro' | 'expert';
  billingCycle: 'MONTHLY' | 'YEARLY';
  currency: 'CZK' | 'EUR';
};
const KEY = 'purchaseIntent';
export function parseIntent(value: unknown): PurchaseIntent | null {
  if (!value || typeof value !== 'object') return null;
  const v = value as Record<string, unknown>;
  if (
    !['pro', 'expert'].includes(v.planId as string) ||
    !['MONTHLY', 'YEARLY'].includes(v.billingCycle as string) ||
    !['CZK', 'EUR'].includes(v.currency as string) ||
    (v.billingCycle === 'YEARLY' && v.planId !== 'expert')
  )
    return null;
  return {
    planId: v.planId,
    billingCycle: v.billingCycle,
    currency: v.currency,
    ...(v.source === 'trial' && v.planId === 'expert' && v.billingCycle === 'MONTHLY'
      ? { source: 'trial' }
      : {}),
  } as PurchaseIntent;
}
export function saveIntent(intent: PurchaseIntent) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...intent, savedAt: Date.now() }));
  } catch {
    /* appState still preserves the selection */
  }
}
export function readIntent(): PurchaseIntent | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return value && Date.now() - value.savedAt < 24 * 60 * 60 * 1000 ? parseIntent(value) : null;
  } catch {
    return null;
  }
}
export function clearIntent() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Storage may be disabled */
  }
}
export function intentFromSearch(search: string) {
  const params = new URLSearchParams(search);
  return parseIntent({
    source: params.get('source'),
    planId: params.get('planId') ?? params.get('plan'),
    billingCycle: params.get('billingCycle') ?? params.get('billingPeriod') ?? 'MONTHLY',
    currency: params.get('currency') ?? 'CZK',
  });
}
